var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"toggleable":"lg","type":"light","variant":"light"}},[(_vm.userProfile)?_c('b-navbar-brand',[_vm._v(_vm._s(_vm.userProfile.company_name))]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }